module.exports = __webpack_public_path__ + "static/media/431223804_1395652537823265_1675117500114496715_n.4bdd233d.jpg";